import { Flex, Switch, Box } from "@chakra-ui/react";
import { useIntl } from "react-intl";

import { AssetState } from "__graphql__/types";
import { BodyM, TitleM } from "ui/Typography/Typography";

export function BatteryDetailsCard({
  state,
  model,
  brand,
  id,
  onToggle,
  isToggling = false,
}: {
  state: AssetState;
  model: string;
  brand: string;
  id: string;
  onToggle?: (newState: AssetState) => void;
  isToggling?: boolean;
}) {
  const intl = useIntl();

  return (
    <Flex p="s200" direction="column" gap="s200" borderRadius="sm" bg="white">
      <BodyM noOfLines={1} wordBreak="break-all">
        <strong>{model}</strong> {id}
      </BodyM>
      <Flex alignItems="center" gap="s100">
        <Switch
          variant="positiveNegative"
          size="md"
          isChecked={state === AssetState.asset_state_operational}
          isDisabled={isToggling}
          onChange={() => {
            const newState =
              state === AssetState.asset_state_operational
                ? AssetState.asset_state_defect
                : AssetState.asset_state_operational;
            onToggle?.(newState);
          }}
        />
        <BodyM>{intl.formatMessage({ id: "pages.inventory.battery-details-page.switch" })}</BodyM>
      </Flex>
      <Box>
        <TitleM color="grey.800" mb="s25">
          {intl.formatMessage({ id: "pages.inventory.battery-details-page.brand" })}
        </TitleM>
        <BodyM>{brand}</BodyM>
      </Box>
      <Box>
        <TitleM color="grey.800" mb="s25">
          {intl.formatMessage({ id: "pages.inventory.battery-details-page.model" })}
        </TitleM>
        <BodyM>{model}</BodyM>
      </Box>
    </Flex>
  );
}
